<kl-grid
  [columns]="[
    {
      header: 'type' | translate,
      binding: 'type',
      translate: true,
      visible: true
    },
    {
      header: 'description' | translate,
      binding: 'description',
      width: '*',
      visible: true
    }
  ]"
  [filterable]="false"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'role',
    name: 'user_roles',
    form: 'ROLE',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'MANAGEMENT'"
  [moduleName]="'ROLE_LIST'"
  [gridName]="'grdRoleList'"
>
</kl-grid>
